import "./CarrinhoEntrega.css";
import { useNavigate } from "react-router-dom";

export default function CarrinhoEntrega() {
  const navigate = useNavigate();

  return (
    <aside className="carrinho-entrega">
      <div className="icone-entrega">
        🚚
      </div>

      <div className="texto-entrega">
        <h3>Entrega</h3>

        <p>
          Após a confirmação do pedido, nossa equipe incluirá a entrega
          na próxima carga programada para a região da sua empresa.
        </p>

        <button
          type="button"
          className="btn-acompanhar-pedido"
          onClick={() => navigate("/pedidos")}
        >
          Acompanhe seu pedido
        </button>
      </div>
    </aside>
  );
}